import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: () => import('../views/HomeView.vue'),
  },
  // {
  //   path: '/mealplan/:id',
  //   name: 'MealPlan',
  //   component: () => import(/* webpackChunkName: "mealplan" */ '../views/MealPlan.vue'),
  //   props: true
  // },
  // {
  //   path: '/recipe/:id',
  //   name: 'Recipe',
  //   component: () => import(/* webpackChunkName: "recipe" */ '../views/Recipe.vue'),
  //   props: true
  // },
  // {
  //   path: '/shoppingList/',
  //   name: 'ShoppingList',
  //   component: () => import(/* webpackChunkName: "shoppinglist" */ '../views/ShoppingList.vue')
  // },
  /// ADMIN
  {
    path: '/admin/',
    name: 'HomeView',
    component: () => import('../views/HomeView.vue'),
    children: [
      // Login
      {
        path: 'login',
        name: 'LoginView',
        component: () => import('../views/LoginView.vue'),
      },
      // Manage users etc
      {
        path: 'manage',
        name: 'ManageView',
        component: () => import('../views/ManageView.vue'),
      },
      // meal plans
      {
        path: 'mealplans',
        name: 'MealPlanListVIew',
        component: () => import('../views/MealPlanListView.vue'),
      },
      {
        path: 'mealplans/:id',
        name: 'MealPlanView',
        component: () => import( '../views/MealPlanView.vue'),
        props: true
      },
      // recipes
      {
        path: 'recipes',
        name: 'RecipeListView',
        component: () => import('../views/RecipeListView.vue'),
      },
      {
        path: 'recipes/:id',
        name: 'RecipeView',
        component: () => import('../views/RecipeView.vue'),
        props: true
      },
      // ingredients
      {
        path: 'ingredients',
        name: 'IngredientListView',
        component: () => import('../views/IngredientListView.vue'),
      },
      {
        path: 'ingredients/import',
        name: 'BulkImportIngredientsView',
        component: () => import('../views/BulkImportIngredientsView.vue'),
      },
      {
        path: 'ingredients/:id',
        name: 'IngredientView',
        component: () => import('../views/IngredientView.vue'),
        props: true
      },
      // preps
      {
        path: 'preps',
        name: 'PrepTermListView',
        component: () => import('../views/PrepTermListView.vue'),
      },
      {
        path: 'preps/:id',
        name: 'PrepTermView',
        component: () => import('../views/PrepTermView.vue'),
        props: true
      },
      // ingredient units
      {
        path: 'units',
        name: 'IngredientUnitListView',
        component: () => import('../views/IngredientUnitListView.vue'),
      },
      {
        path: 'units/:id',
        name: 'IngredientUnitView',
        component: () => import('../views/IngredientUnitView.vue'),
        props: true
      },
      // ingredient aisles
      {
        path: 'ingredientAisles',
        name: 'IngredientAisleListView',
        component: () => import('../views/IngredientAisleListView.vue'),
      },
      {
        path: 'ingredientAisles/:id',
        name: 'IngredientAisleView',
        component: () => import('../views/IngredientAisleView.vue'),
        props: true
      },
      // tips & encouragements
      {
        path: 'tipsEncouragements',
        name: 'TipsEncouragementListView',
        component: () => import('../views/TipsEncouragementListView.vue'),
      },
      {
        path: 'tipsEncouragements/:id',
        name: 'TipEncouragementView',
        component: () => import('../views/TipEncouragementView.vue'),
        props: true
      },
      {
        path: 'recipeCollections',
        name: 'RecipeCollectionListView',
        component: () => import('../views/RecipeCollectionListView.vue'),
      },
      {
        path: 'recipeCollections/:id',
        name: 'RecipeCollectionView',
        component: () => import('../views/RecipeCollectionView.vue'),
        props: true
      },
      {
        path: 'mealPlanCollections',
        name: 'MealPlanCollectionListView',
        component: () => import('../views/MealPlanCollectionListView.vue'),
      },
      {
        path: 'mealPlanCollections/:id',
        name: 'MealPlanCollectionView',
        component: () => import('../views/MealPlanCollectionView.vue'),
        props: true
      },
      {
        path: 'partnerCampaigns',
        name: 'PartnerCampaignListView',
        component: () => import('../views/PartnerCampaignListView.vue'),
      },
      {
        path: 'partnerCampaigns/:id',
        name: 'PartnerCampaignView',
        component: () => import('../views/PartnerCampaignView.vue'),
        props: true
      },
      // users
      {
        path: 'users',
        name: 'UserListView',
        component: () => import('../views/UserListView.vue'),
      },
      {
        path: 'users/:id',
        name: 'UserView',
        component: () => import('../views/UserView.vue'),
        props: true
      },
      // Tag Management
      {
        path: 'tags',
        name: 'TagManagementView',
        component: () => import('../views/TagManagementView.vue'),
      },
      // Seasonal Ingredients
      {
        path: 'seasonalIngredients',
        name: 'SeasonalIngredientsView',
        component: () => import('../views/SeasonalIngredientsView.vue'),
      },
    ]
  },
]

// List views that should preserve scroll and pagination state
const LIST_VIEWS = [
  'MealPlanListVIew', 'RecipeListView', 'IngredientListView',
  'PrepTermListView', 'IngredientUnitListView', 'IngredientAisleListView',
  'TipsEncouragementListView', 'RecipeCollectionListView',
  'MealPlanCollectionListView', 'PartnerCampaignListView', 'UserListView'
]

// Helper functions for storing/retrieving list view state
function saveListState(routeName) {
  const state = {
    scrollY: window.pageYOffset,
    scrollX: window.pageXOffset
  }
  sessionStorage.setItem(`feeds_list_state_${routeName}`, JSON.stringify(state))
}

function getListState(routeName) {
  const stored = sessionStorage.getItem(`feeds_list_state_${routeName}`)
  return stored ? JSON.parse(stored) : null
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    // Check if navigating to a list view that has saved state
    if (LIST_VIEWS.includes(to.name)) {
      const savedState = getListState(to.name)
      if (savedState && savedState.scrollY > 0) {
        return new Promise((resolve) => {
          // Wait for DOM to render and data to load before scrolling
          setTimeout(() => {
            resolve({ x: savedState.scrollX, y: savedState.scrollY })
          }, 300)
        })
      }
    }

    return { x: 0, y: 0 }
  }
})

// Save scroll position before navigating away from list views
router.beforeEach((to, from, next) => {
  if (LIST_VIEWS.includes(from.name)) {
    saveListState(from.name)
  }

  next()
})

// Authentication
router.beforeEach((to, from, next) => {
  // if we're not authenticated & admin
  if ((to.name != 'LoginView') && !(Store.state.isAuthenticated && Store.state.user.admin)) next({name: 'LoginView'})
  else next()
})

export default router
